import { action } from "typesafe-actions";
import {
  CheckinReleaseTypes,
  CheckinReleaseParams,
  CheckinReleaseList,
  CheckinReleasePayload,
} from "./types";

export const loadRequest = (params: CheckinReleaseParams) =>
  action(CheckinReleaseTypes.LOAD_REQUEST, params);

export const loadSuccess = (data: CheckinReleaseList[]) =>
  action(CheckinReleaseTypes.LOAD_SUCCESS, data);

export const loadFailure = () =>
  action(CheckinReleaseTypes.LOAD_FAILURE);

export const releaseCheckinRequest = (payload: CheckinReleasePayload) =>
  action(CheckinReleaseTypes.RELEASE_CHECKIN_REQUEST, payload);
